import { ImageIcon, Eye } from "lucide-react";

interface DrillPreviewSectionProps {
  previewImageUrl?: string | null;
  description?: string;
  onPreview: () => void;
}

export const DrillPreviewSection = ({
  previewImageUrl,
  description,
  onPreview,
}: DrillPreviewSectionProps) => {
  return (
    <div className="space-y-4">
      <div 
        className="cursor-pointer group relative h-[200px] bg-gray-50 rounded-lg overflow-hidden"
        onClick={onPreview}
      >
        {previewImageUrl ? (
          <img
            src={previewImageUrl}
            alt="Drill preview"
            className="w-full h-full object-contain"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-gray-400">
            <ImageIcon className="h-12 w-12 opacity-20" />
            <p className="text-sm mt-2">No preview available</p>
          </div>
        )}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
          <Eye className="text-transparent group-hover:text-white h-8 w-8" />
        </div>
      </div>
      <p className="text-sm text-gray-600 mt-2 line-clamp-3">
        {description || "No description available"}
      </p>
    </div>
  );
};